module.exports = {
          srcSet: __webpack_public_path__ + "d66d5a23780035d16a649c49b380aae7-72.png"+" 72w",
          images:[ {path: __webpack_public_path__ + "d66d5a23780035d16a649c49b380aae7-72.png",width: 72,height: 70}],
          src: __webpack_public_path__ + "d66d5a23780035d16a649c49b380aae7-72.png",
          toString:function(){return __webpack_public_path__ + "d66d5a23780035d16a649c49b380aae7-72.png"},
          
          width: 72,
          height: 70
        }